import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { UseOverlayComponent } from './styles';
export function useOverlay(props) {
    const { defaultShowOverlay, topGap } = props || {};
    const [showOverlay, setShowOverlay] = useState(!!defaultShowOverlay);
    useEffect(() => {
        setShowOverlay(!!defaultShowOverlay);
    }, [defaultShowOverlay]);
    return {
        handleShowOverlay: setShowOverlay,
        isOverlayOpen: showOverlay,
        OverlayComponent: ({ onClick }) => (_jsx(UseOverlayComponent, { "data-testid": "overlay", topGap: topGap, showOverlay: showOverlay, onClick: onClick })),
    };
}
//# sourceMappingURL=index.js.map